import { render } from "./QuotationDetails.vue?vue&type=template&id=8532eee8&ts=true"
import script from "./QuotationDetails.vue?vue&type=script&lang=ts"
export * from "./QuotationDetails.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__